import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-screen-capture-preview',
  templateUrl: './screen-capture-preview.component.html',
  styleUrls: ['./screen-capture-preview.component.scss']
})
export class ScreenCapturePreviewComponent implements OnInit {

  @Input() url;

  constructor() { }

  ngOnInit() {
  }

}
